import React from 'react'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { useFilter } from '../../Hook/App'
import RenderOption from '../../Components/RenderOption';
import { Link } from 'react-router-dom';
import Category from '../Category'
function Index() {
    const { setData, filter, onChange, category, setpage, page, } = useFilter();

    if (page == 'category') {
        return <Category callback={(res) => {
            setpage('');
            onChange({ target: { name: "category_id", value: res.id } });
            setData('category', res, null, true);
        }} />
    }
    let sortAsc = false;
    let sortDesc = false;
    if (filter) {
        if (filter.sort == 'desc') {
            sortDesc = true;
            sortAsc = false;
        } else {
            sortDesc = false;
            sortAsc = true;
        }
    }
    return (
        <Layout nav={false}>
            <HeaderMain lable="بازگشت" />
            <div className="filters-main">
                <div className="box">
                    <p className="blue">مرتب سازی</p>
                    <div className="row">
                        <div className="col-6 mb-4 align-items-center d-flex">
                            <input className="checkbox" type="radio" name='sort' value="desc" onChange={onChange} checked={sortDesc} />
                            <span className="light-text">جدید ترین</span>
                        </div>
                        <div className="col-6 mb-4 align-items-center d-flex">
                            <input className="checkbox" type="radio" name='sort' value="asc" onChange={onChange} checked={sortAsc} />
                            <span className="light-text">قدیمی ترین</span>
                        </div>
                    </div>

                </div>
                <div className="box my-3">
                    <div className="light-text">دسته بندی</div>
                    <select className="select" name="category_id" onClick={() => { setpage('category') }}>
                        {category ? <option value={category.id}>{category.title}</option>
                            : <option value="">همه گروهبندی ها</option>}
                    </select>
                </div>
                {category && category.all_option && category.all_option.map((option, i) => <div key={i} className="box my-3"> <RenderOption filter={filter} onChange={onChange} option={option} /></div>)}
                <div className="box">
                    <input type="checkbox" name='hasimage' onChange={({ target }) => {
                        onChange({ target: { name: target.name, value: target.checked } })
                    }} checked={filter && filter.hasimage} />
                    <span>فقط آگهی های عکس دار</span>
                </div>
                <Link to={'/ProductList'} state={{ category: category }} className="btn mt-5">اعمال فیلتر</Link>
            </div>
        </Layout>
    )
}

export default Index